import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import {
    GET_CARD_DATA_SUCCESS,
    GET_CARD_DATA_FAILURE,
    GET_VIEW_DATA_SUCCESS,
    GET_VIEW_DATA_FAILURE,
    GET_SEARCH_CARD_DATA_SUCCESS,
    GET_SEARCH_CARD_DATA_FAILURE,
    GET_CARD_PREVIEW_DETAILS_SUCCESS,
    GET_CARD_PREVIEW_DETAILS_FAILURE,
    GET_LIST_DATA_SUCCESS,
    GET_LIST_DATA_FAILURE,
} from '../actions';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { convertObjectToQueryParams } from 'src/utils/util';
import { setOrderSummaryModalState } from 'src/pages/orders/redux/actions';
import { select } from 'redux-saga/effects';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

// Defensive helper: if a payload contains startDate/endDate where end < start,
// swap them so the API never receives an inverted range.
const sanitizeDateRange = (payload) => {
    if (!payload || !payload.startDate || !payload.endDate) return payload;
    const start = new Date(payload.startDate);
    const end = new Date(payload.endDate);
    if (
        !isNaN(start.getTime()) &&
        !isNaN(end.getTime()) &&
        end.getTime() < start.getTime()
    ) {
        return {
            ...payload,
            startDate: payload.endDate,
            endDate: payload.startDate,
        };
    }
    return payload;
};

export function* getViewData(action) {
    const { assignedFlag } = yield select(
        (state) => ({
            assignedFlag:
            state.appliedFiltersReducer.displayOrderCondition
        })
    );
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/scheduledsurgeries?`;

    const resourceType = 'VIEW_DATA';
    const params = convertObjectToQueryParams({
        ...sanitizeDateRange(action.payload),
        resourceType: resourceType,
    });
    let finalUrl = url + `${params}&assignedFlag=${assignedFlag}`;
    try {
        const result = yield axios
            .get(finalUrl)
            .then((response) => response.data);

        yield put({
            type: GET_VIEW_DATA_SUCCESS,
            data: { ...result, resourceType },
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: finalUrl,
            requestPayload: action.payload,
        });
        yield put({
            type: GET_VIEW_DATA_FAILURE,
            templateError: errorHandler('503'),
            resourceType,
        });
    }
}

export function* getCardData(action) {
    const { assignedFlag } = yield select(
        (state) => ({
            assignedFlag:
            state.appliedFiltersReducer.displayOrderCondition
        })
    );
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/scheduledsurgeries?`;

    const resourceType = 'CARD_DATA';
    const params = convertObjectToQueryParams({
        ...sanitizeDateRange(action.payload),
        resourceType: resourceType,
    });
    let finalUrl = url + `${params}&assignedFlag=${assignedFlag}`;
    try {
        const result = yield axios
            .get(finalUrl)
            .then((response) => response.data);

        yield put({
            type: GET_CARD_DATA_SUCCESS,
            data: { ...result, resourceType },
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: finalUrl,
            requestPayload: action.payload,
        });
        yield put({
            type: GET_CARD_DATA_FAILURE,
            templateError: errorHandler('503'),
            resourceType,
        });
    }
}

export function* getSearchCardData(action) {
    const { assignedFlag } = yield select(
        (state) => ({
            assignedFlag:
            state.appliedFiltersReducer.displayOrderCondition
        })
    );
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/scheduledsurgeries?`;

    const resourceType = 'CARD_DATA';
    const params = convertObjectToQueryParams({
        ...sanitizeDateRange(action.payload),
        resourceType: resourceType,
    });
    let finalUrl = url + `${params}&assignedFlag=${assignedFlag}`;
    try {
        const result = yield axios
            .get(finalUrl)
            .then((response) => response.data);

        yield put({
            type: GET_SEARCH_CARD_DATA_SUCCESS,
            data: { ...result, resourceType: 'SEARCH_CARD_DATA' },
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: finalUrl,
            requestPayload: action.payload,
        });
        yield put({
            type: GET_SEARCH_CARD_DATA_FAILURE,
            templateError: errorHandler('503'),
            resourceType,
        });
    }
}

export function* getListData(action) {
    const { assignedFlag } = yield select(
        (state) => ({
            assignedFlag:
            state.appliedFiltersReducer.displayOrderCondition
        })
    );
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/scheduledsurgeries?`;
    const resourceType = 'LIST_DATA';
    const params = convertObjectToQueryParams({
        ...sanitizeDateRange(action.payload),
        resourceType: resourceType,
    });
    let finalUrl = url + `${params}&assignedFlag=${assignedFlag}`;
    try {
        const result = yield axios
            .get(finalUrl)
            .then((response) => response.data);

        yield put({
            type: GET_LIST_DATA_SUCCESS,
            data: { ...result, resourceType },
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: finalUrl,
            requestPayload: action.payload,
        });
        yield put({
            type: GET_LIST_DATA_FAILURE,
            templateError: errorHandler('503'),
            resourceType,
        });
    }
}

export function* getCardPreview(action) {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/surgery/preview?`;
    const params = convertObjectToQueryParams({
        myCaseRef: action?.payload?.myCaseRef,
    });
    let finalUrl = url + `${params}`;
    try {
        const result = yield axios
            .get(finalUrl)
            .then((response) => response.data.surgeryData);

        yield put({
            type: GET_CARD_PREVIEW_DETAILS_SUCCESS,
            data: { result: result },
        });
        if (result.surgeryDetails.lastModifiedDate) {
            yield put(
                setOrderSummaryModalState({
                    orderSummaryModal: true,
                })
            );
        }
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: finalUrl,
            requestPayload: action.payload,
        });
        yield put({
            type: GET_CARD_PREVIEW_DETAILS_FAILURE,
            cardPreviewError: errorHandler('503'),
        });
    }
}
